import {useCallback, useMemo} from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Alert from '@mui/material/Alert'
import IconButton from '@mui/material/IconButton'
import {
  StyledArrowForwardIcon,
  StyledCompletedProjectContainer,
  StyledGroupTablePaper,
  StyledProjectNameContainer,
  StyledWarningIcon
} from './ClientAccordionStyle'
import ReusableTable from '../common/ReusableTable/ReusableTable'
import {useNavigate} from 'react-router-dom'

const ClientAccordionContent = ({group}) => {
  const {loadingGroups, errorGroups, group: groupData} = group
  const navigate = useNavigate()

  const handleViewProject = useCallback(
    (event, projectId) => {
      event.stopPropagation()

      if (!projectId) return
      navigate(`/adminPanel/client/${group.group.groupList.CLIENT_ID}/project/${projectId}`)
    },
    [navigate, group]
  )

  const onProjectRowClick = useCallback(
    (event, selectedProject) => {
      handleViewProject(event, selectedProject.GROUP_ID)
    },
    [handleViewProject]
  )

  const columns = useMemo(
    () => [
      {
        field: 'GROUP_NAME',
        headerName: '',
        renderCell: (row) =>
          row.IS_COMPLETED ? (
            <StyledCompletedProjectContainer>{row.GROUP_NAME}</StyledCompletedProjectContainer>
          ) : (
            <StyledProjectNameContainer>
              <StyledWarningIcon />
              {row.GROUP_NAME}
            </StyledProjectNameContainer>
          )
      },
      {
        field: 'TOTAL_ACTIVE_USERS',
        align: 'right',
        cellSx: {
          color: (theme) => theme.palette.text.secondary,
          fontSize: (theme) => theme.typography.body2.fontSize,
          marginLeft: '16px'
        },
        renderCell: (row) => `Active Members: ${row.TOTAL_ACTIVE_USERS}`
      },
      {
        field: 'actions',
        align: 'right',
        cellSx: {width: '40px'},
        disableSearch: true,
        renderCell: (row) => (
          <IconButton onClick={(event) => handleViewProject(event, row.GROUP_ID)} color='primary' size='small'>
            <StyledArrowForwardIcon />
          </IconButton>
        )
      }
    ],
    [handleViewProject]
  )

  if (loadingGroups && !errorGroups) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' height='100px'>
        <CircularProgress />
      </Box>
    )
  }

  if (errorGroups && !loadingGroups) {
    return (
      <Box py={2}>
        <Alert severity='error'>Error loading group details</Alert>
      </Box>
    )
  }

  const groupList = groupData?.groupList?.GROUPList ?? []

  return (
    <Box pt={2}>
      {groupList.length > 0 ? (
        <Box mb={1}>
          <ReusableTable
            data={groupList}
            columns={columns}
            getRowKey={(row) => row.GROUP_ID}
            emptyMessage='No projects available'
            paperProps={{variant: 'elevation', component: StyledGroupTablePaper}}
            onRowClick={onProjectRowClick}
          />
        </Box>
      ) : (
        <ReusableTable data={[]} columns={columns} emptyMessage='No projects available' />
      )}
    </Box>
  )
}

ClientAccordionContent.propTypes = {
  group: PropTypes.object
}

export default ClientAccordionContent
